/**
 * Created by tomers on 5/26/2015.
 */
define(function (require) {
    "use strict";

    var LE = require("app");
    var BaseModel = require("models/BaseModel");
    var ApiResources = require("assets/data/apiResources.json");

    var ROLES = {
        AGENT: "operators",
        AGENT_MANAGER: "agent managers",
        CAMPAIGN_MANAGER: "campaign managers",
        ADMINISTRATOR: "administrators",
    };

    var PermissionGroupModel = {};

    function moduleDefinition(LEUserManagement, LE, Backbone, Marionette, $, _) {
        PermissionGroupModel = BaseModel.extend({
            ROLES: ROLES,
            resource: ApiResources.AppServer.PermissionGroups,
            name: "PermissionGroupModel",
            getModelKey: function () {
                var name = this.get("name");
                var key = name.replace(/ /g, "_"); // replace spaces with underscores
                return key;
            },
            getTranslatedName: function() {
                if (!this.translatedName) {
                    this.translatedName = LE.translator.translate("LEUserManagement.permissionGroup." + this.getModelKey() + ".name");
                }
                return this.translatedName;
            }
        });
    }

    LE.module("LEUserManagement", moduleDefinition);

    PermissionGroupModel.ROLES = ROLES;

    return PermissionGroupModel;
});
